import { render, staticRenderFns } from "./CustomerListView.vue?vue&type=template&id=038969f6"
import script from "./CustomerListView.vue?vue&type=script&lang=js"
export * from "./CustomerListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports